/** Links from before the homepage became the story page pointed at `/?graph=…` or `/?tour=…`. */
const GRAPH_PARAMS = ["graph", "tour", "tour-mode", "tour-speed"];

export function legacyGraphRedirect(search: string): string | null {
  const params = new URLSearchParams(search);
  return GRAPH_PARAMS.some((name) => params.has(name)) ? `/graph${search}` : null;
}
